import { type ChangeEvent, useEffect, useState } from 'react';
import { Checkbox, FormControlLabel, Grid, Typography } from '@material-ui/core';

import { Button, Dialog, NoResults, TextField } from 'src/components';
import { type IQuestion } from 'src/models';
import { type RootState } from 'src/store';
import { useDispatch, useSelector } from 'react-redux';
import { userTypes } from 'src/helpers/constants';
import sectionActions from 'src/store/Sections/actions';
import useStyles from './Questions-styles';

import Question from './Question';
import QuestionDialog from './QuestionDialog';

function Questions() {
	const classes = useStyles();
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();

	const section = useSelector((state: RootState) => state.sections.section);
	const user = useSelector((state: RootState) => state.auth.data);
	const updateShowRandom = (id: number, value: boolean) =>
		dispatch(sectionActions.updateShowRandom(id, value));
	const updateQuestionsInExam = (id: number, value: string) =>
		dispatch(sectionActions.updateQuestionsExam(id, value));

	const [questions, setQuestions] = useState(section?.questions || []);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [questionsInExamOpen, setQuestionsInExamOpen] = useState(false);
	const [showRandom, setShowRandom] = useState(false);
	const [questionsInExam, setQuestionsInExam] = useState('');

	useEffect(() => {
		setQuestions(section?.questions || []);
		setShowRandom(section.showRandom);
		setQuestionsInExam(section.questionsInExam?.toString());
	}, [section.id]);

	function handleShowRandom(event: ChangeEvent<HTMLInputElement>) {
		setShowRandom(event.target.checked);
		updateShowRandom(section.id, event.target.checked);
	}

	function handleQuestionsInExamClose() {
		setQuestionsInExam(section.questionsInExam.toString());
		setQuestionsInExamOpen(false);
	}

	function handleSaveQuestionsInExam() {
		updateQuestionsInExam(section.id, questionsInExam);
		setQuestionsInExamOpen(false);
	}

	return (
		<Grid container>
			<QuestionDialog
				handleOpen={() => {
					setDialogOpen(false);
				}}
				isNew
				open={dialogOpen}
				sectionId={section.id}
			/>

			<Dialog
				actions={
					<Button
						actionType={'save'}
						disabled={
							questionsInExam.length === 0 || parseInt(questionsInExam) > questions.length
						}
						onClick={handleSaveQuestionsInExam}
					>
						Guardar
					</Button>
				}
				content={
					<TextField
						error={parseInt(questionsInExam) > questions.length}
						label={`Preguntas en examen (Máximo ${questions.length})`}
						onChange={(e: ChangeEvent<HTMLInputElement>) => {
							setQuestionsInExam(e.target.value);
						}}
						value={questionsInExam}
					/>
				}
				handleOpen={handleQuestionsInExamClose}
				maxWidth={'sm'}
				open={questionsInExamOpen}
				title={'Nueva Sección'}
			/>

			<h2> Preguntas </h2>

			{questions.length === 0 ? (
				<NoResults text={'Aún no hay preguntas'} />
			) : (
				<Grid container>
					<div className={classes.config}>
						<FormControlLabel
							control={
								<Checkbox
									checked={showRandom}
									color={'secondary'}
									disabled={!(user.type === userTypes.ADMIN)}
									onChange={handleShowRandom}
								/>
							}
							label={'Mostrar preguntas aleatoriamente'}
						/>

						<div className={classes.questionsNumber}>
							<Button
								color={'primary'}
								onClick={() => {
									if (user.type === userTypes.ADMIN) setQuestionsInExamOpen(true);
								}}
								variant={'outlined'}
							>
								{`Preguntas en examen: ${questionsInExam} / ${questions.length}`}
							</Button>
						</div>
					</div>

					{questions.map((question: IQuestion, index: number) => (
						<Question key={index} question={question} />
					))}
				</Grid>
			)}

			<Grid className={classes.actions} item xs={12}>
				{user.type === userTypes.ADMIN && (
					<Button
						actionType={'add'}
						onClick={() => {
							setDialogOpen(true);
						}}
					>
						Agregar pregunta
					</Button>
				)}
			</Grid>
		</Grid>
	);
}

export default Questions;
